import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { FileSignature, Loader2 } from "lucide-react";

const ROLES = [["workshop", "عقد الورش"], ["tow_provider", "عقد السطحات"]];

export function ContractTemplatesDialog() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    if (open) api.get("/admin/contracts").then((r) => setData(r.data));
  }, [open]);

  const save = async (role) => {
    setBusy(role);
    try {
      await api.put(`/admin/contracts/${role}`, data[role]);
      toast.success("تم حفظ نموذج العقد");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy("");
  };
  const set = (role, k, v) => setData({ ...data, [role]: { ...data[role], [k]: v } });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full gap-2" data-testid="contract-templates-btn"><FileSignature className="w-4 h-4" /> نماذج العقود</Button>
      </DialogTrigger>
      <DialogContent dir="rtl" className="max-w-2xl" data-testid="contract-templates-dialog">
        <DialogHeader><DialogTitle>نماذج عقود الانضمام</DialogTitle></DialogHeader>
        {!data ? <div className="py-8 text-center text-sm text-muted-foreground">جارٍ التحميل...</div> : (
          <Tabs defaultValue="workshop" dir="rtl">
            <TabsList className="grid grid-cols-2 w-full">
              {ROLES.map(([r, l]) => <TabsTrigger key={r} value={r} data-testid={`contract-tab-${r}`}>{l}</TabsTrigger>)}
            </TabsList>
            {ROLES.map(([r]) => (
              <TabsContent key={r} value={r} className="space-y-3 mt-4">
                <Input value={data[r].title} onChange={(e) => set(r, "title", e.target.value)} data-testid={`contract-title-${r}`} />
                <Textarea rows={12} value={data[r].body} onChange={(e) => set(r, "body", e.target.value)} data-testid={`contract-body-${r}`} />
                <p className="text-xs text-muted-foreground">تتعبأ تلقائياً عند الإرسال: {"{الاسم} {التاريخ} {المدينة} {الجوال} {البريد}"}</p>
                <Button className="rounded-xl gap-2 w-full" disabled={busy === r} onClick={() => save(r)} data-testid={`contract-save-${r}`}>
                  {busy === r && <Loader2 className="w-4 h-4 animate-spin" />} حفظ النموذج
                </Button>
              </TabsContent>
            ))}
          </Tabs>
        )}
      </DialogContent>
    </Dialog>
  );
}
